import React from "react";
import igovttLogo from "../../assets/igovtt.png";
import mpaaiLogo from "../../assets/mpaai.png";

export const Footer: React.FC = () => {
	return (
		<div className="vt-footer" aria-label="Footer">
			<div className="vt-footer-inner">
				<div className="vt-footer-top">
					<div
						className="vt-footer-top-row"
						style={{
							alignItems: "center",
							gap: "32px",
							flexWrap: "wrap",
							justifyContent: "space-between",
						}}
					>
						<div
							style={{
								display: "flex",
								alignItems: "center",
								gap: "32px",
								flexWrap: "wrap",
							}}
						>
							<div className="vt-footer-brand">
								<div className="vt-footer-logo-row">
									<div
										className="vt-footer-logo-wrapper"
										aria-label="VerifyTT logo"
									>
										<img
											alt="logo"
											src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/logo.svg"
										/>
									</div>
								</div>
								<div className="vt-footer-tagline">
									Trusted Credentials. Verified.
								</div>
							</div>

							<div
								style={{
									display: "flex",
									alignItems: "center",
									gap: "14px",
									flexWrap: "wrap",
								}}
							>
								<img
									src={igovttLogo}
									alt="iGovTT logo"
									style={{
										height: "76px",
										width: "auto",
										objectFit: "contain",
									}}
								/>
								{/* <img
									src={mpaaiLogo}
									alt="MPAAI logo"
									style={{
										height: "76px",
										width: "auto",
										objectFit: "contain",
									}}
								/> */}
							</div>
						</div>

						<div
							className="vt-footer-ministry"
							aria-label="About the initiative"
						>
							An Initiative of the Ministry of Public
							Administration and Artificial Intelligence and The
							National Information and Communication Technology
							Company Limited.
						</div>
					</div>
				</div>

				<div className="vt-footer-divider-wrapper">
					<div className="vt-footer-divider" />
				</div>

				<div className="vt-footer-bottom">
					<div className="vt-footer-copy">
						©2025 VerifyTT · All rights reserved.
					</div>

					<div className="vt-footer-links" aria-label="Footer links">
						{/* <div className="vt-footer-link-item">
							<div className="vt-footer-link-inner">
								<div className="vt-footer-link-text-wrapper">
									<div className="vt-footer-link-text">
										Term of use
									</div>
								</div>
							</div>
						</div> */}

						<div className="vt-footer-link-item">
							<div className="vt-footer-link-inner">
								<div className="vt-footer-link-text-wrapper">
									<div className="vt-footer-link-text">
										<a
											href="/privacy-policy"
											aria-label="Privacy policy"
										>
											Privacy policy
										</a>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
